// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__23WlE","inputDescription":"styles_inputDescription__3NwmQ"};